<script setup lang="ts">
import type {
  PeekPriceModalFerryPlusHotelItinerary,
  PeekPriceModalFlightPlusHotelItinerary,
} from '../../models';

import PeekPriceBookableTransportCard from './PeekPriceBookableTransportCard.vue';
import PeekPriceSimpleHotelCard from './PeekPriceSimpleHotelCard.vue';

interface PeekPriceBookableTransportPlusHotelProps {
  itinerary:
    | PeekPriceModalFlightPlusHotelItinerary
    | PeekPriceModalFerryPlusHotelItinerary;
}

const props = defineProps<PeekPriceBookableTransportPlusHotelProps>();
</script>

<template>
  <div class="peek-price-bookable-transport-plus-hotel">
    <div class="title">
      {{ $t('planner.your_trip_at_departure') }}
      {{ props.itinerary.tripDeparture }}
    </div>
    <PeekPriceBookableTransportCard
      :data="itinerary.departureTransport"
      class="product-card"
    />
    <PeekPriceSimpleHotelCard
      :data="props.itinerary.hotel"
      class="product-card"
    />
    <PeekPriceBookableTransportCard :data="props.itinerary.arrivalTransport" />
  </div>
</template>

<style scoped lang="scss">
.peek-price-bookable-transport-plus-hotel {
  .title {
    @include font-label-l-bold;
    margin-bottom: var(--spacing-16);
  }

  .product-card {
    padding-bottom: var(--spacing-16);
    margin-bottom: var(--spacing-16);
    border-bottom: 1px solid var(--color-neutral-20);
  }
}
</style>
